export const assetBasePath = process.env.PUBLIC_URL + '/assets';
export const compSize = 128;

// Legacy
const config = {
  assetBasePath,
  compSize,
};
export default config;
